import React from 'react';

const PrivacyKvkk = () => {
    return (
        <div className="container mx-auto px-4 py-10 max-w-4xl">
            <h1 className="text-3xl font-bold mb-6">Gizlilik Politikası ve KVKK Aydınlatma Metni</h1>

            <div className="space-y-6 text-gray-700">
                <section>
                    <h2 className="text-xl font-bold mb-2 text-black">1. Veri Sorumlusu</h2>
                    <p>
                        Kodu Tara olarak kişisel verilerinizin güvenliği hususuna azami hassasiyet göstermekteyiz.
                        Bu bilinçle, ürün ve hizmetlerimizden faydalanan kişiler dahil, Şirketimiz ile ilişkili
                        tüm şahıslara ait her türlü kişisel verilerin 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVK Kanunu")'na
                        uygun olarak işlenerek, muhafaza edilmesine büyük önem atfetmekteyiz.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-bold mb-2 text-black">2. Kişisel Verilerin Toplanması ve İşlenmesi</h2>
                    <p>
                        Kişisel verileriniz, şirketimiz tarafından sağlanan hizmetlere bağlı olarak değişkenlik gösterebilmekle birlikte;
                        otomatik ya da otomatik olmayan yöntemlerle, internet sitemiz, sosyal medya mecralarımız, mobil uygulamalarımız
                        ve benzeri vasıtalarla sözlü, yazılı ya da elektronik olarak toplanabilecektir.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-bold mb-2 text-black">3. İşlenen Kişisel Veriler</h2>
                    <p>
                        Hizmetlerimizden yararlanmanız sırasında aşağıdaki verileriniz işlenebilir:
                    </p>
                    <ul className="list-disc pl-5 mt-2 space-y-1">
                        <li>Ad, soyad,TC kimlik no, iletişim bilgileri (telefon, e-posta vb.)</li>
                        <li>Araç plaka bilgisi ve araç ile ilgili notlar</li>
                        <li>QR kod kullanım istatistikleri</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-bold mb-2 text-black">4. Haklarınız</h2>
                    <p>
                        KVK Kanunu'nun 11. maddesi uyarınca veri sahipleri; kişisel verilerinin işlenip işlenmediğini öğrenme,
                        işlenmişse buna ilişkin bilgi talep etme, işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme
                        gibi haklara sahiptir. Haklarınızı kullanmak için sistemimizdeki iletişim kanalları üzerinden şirketimizle irtibata geçebilirsiniz.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default PrivacyKvkk;